import ahoy from "ahoy.js"

// Configure Ahoy
ahoy.configure({
    // Use sendBeacon for reliable tracking during navigation/unloads
    visitDuration: 30, // minutes
    // trackNow: true,  // helps with debugging but might be too aggressive
})

// Force beacon usage if available (Ahoy defaults to true usually, but good to be explicit)
// specific versions of ahoy.js might behave differently.
// Checking source of ahoy.js 0.4.4 - it tries beacon.

// Make it available globally just in case (optional, for debugging)
window.ahoy = ahoy

export default ahoy
